import { useEffect } from 'react';

import { decodePromise } from '~/src/model/Util';
import { AngleConverters, inchConverter } from '~/src/util/Units';

import { Tweaker } from './Figure';
import * as Act from './Figure/Action';
import { State , mkState , getPages , getTweaks } from './Figure/State';
import { Emitter , useTweaker } from './Figure/Hook';
import { Message , resPages , resFigure } from './FigureEmbed/Signals';
import { applyFigureMod } from '~/src/figure/FigureMod';
import { Tabs } from './Tabs';


export const handleMessage = ( emit : Emitter ) => ( state : null | State ) => ( msg : Message ) : void => {
	switch ( msg.tag ) {
	case 'MsgLoadFigure' : {
		emit( Act.setState( mkState( msg.fig ) ) );
		return;
	}
	case 'MsgFocusFigure' : {
		emit( Act.center );
		return;
	}
	case 'MsgDownloadFigure' : {
		if ( !window.parent || !state )
			return;
		window.parent.postMessage( resFigure( applyFigureMod( getTweaks( state ) )( state.figure ) ) , '*' );
		return;
	}
	case 'MsgGetPages' : {
		if ( !window.parent || !state )
			return;
		window.parent.postMessage( resPages( getPages( state ) ) , '*' );
		return;
	}
	case 'MsgSetActive' : {
		emit( Act.setActive( msg.act ) );
		return;
	}
	case 'MsgResetTweaks' : {
		emit( Act.resetTweaks );
		return;
	}
	case 'MsgConfig' : {
		emit( Act.configure( msg.con ) );
		return;
	}
	}
};

export const receiveData = ( emit : Emitter ) => ( state : null | State ) => ( event : MessageEvent ) =>
	decodePromise( Message )( event.data ).then( handleMessage( emit )( state ) ).catch( console.error )
;

export const FigureEmbed = () => {
	const { emit , state } = useTweaker( null );

	useEffect( () => {
		const receive = receiveData( emit )( state );
		window.addEventListener( 'message' , receive );
		return () => window.removeEventListener( 'message' , receive );
	} , [ emit , state ] );

	return (
		<div className="page figure" style={ { height : '100%' , display : 'flex' , flexDirection : 'column' } }>
			{ !state
				? <p>No state yet!</p>
				: <Tweaker
					emit={ emit }
					value={ state }

					width="100%"
					height="100%"

					angleConverter={ AngleConverters.exterior }
					lengthConverter={ inchConverter }
				/>
			}
			{ !state ? null : <Tabs value={ state } emitter={ emit } /> }
		</div>
	);
};

export default FigureEmbed;
